!function() {
  const STORAGE_KEY = 'pbw_age_verified';
  const days = window.ageVerificationDays || 0;
  var modalBound = false;
  var fetchIntercepted = false;

  function setCookie(name, value, cookieDays) {
    var expires = '';
    if (cookieDays) {
      var date = new Date();
      date.setTime(date.getTime() + cookieDays * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax; Secure';
  }

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? match[2] : null;
  }

  function isVerified() {
    try {
      // Check cookie first
      var cookie = getCookie(STORAGE_KEY);
      if (cookie) {
        var data = JSON.parse(decodeURIComponent(cookie));
        if (days === 0) return true;
        return Date.now() - data.time < days * 24 * 60 * 60 * 1000;
      }
      // Fallback to localStorage/sessionStorage
      var stored = days === 0
        ? sessionStorage.getItem(STORAGE_KEY)
        : localStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      var data2 = JSON.parse(stored);
      if (days === 0) return true;
      return Date.now() - data2.time < days * 24 * 60 * 60 * 1000;
    } catch(e) { return false; }
  }

  function setVerified() {
    try {
      var val = encodeURIComponent(
        JSON.stringify({ verified: true, time: Date.now() })
      );
      // Set cookie
      setCookie(STORAGE_KEY, val, days === 0 ? 0 : days);
      // Also set localStorage/sessionStorage as fallback
      var stored = JSON.stringify({ verified: true, time: Date.now() });
      days === 0
        ? sessionStorage.setItem(STORAGE_KEY, stored)
        : localStorage.setItem(STORAGE_KEY, stored);
    } catch(e) {}
  }

  function getModal() {
    var modal = document.getElementById('age-modal');
    if (modal) return modal;

    var template = document.getElementById('age-modal-template');
    if (!template || !template.content) return null;

    document.body.appendChild(template.content.cloneNode(true));
    return document.getElementById('age-modal');
  }

  function bindModalButtons(modal) {
    if (!modal || modalBound) return;
    modalBound = true;

    var yesBtn = modal.querySelector('#age-yes');
    var noBtn = modal.querySelector('#age-no');
    var backBtn = modal.querySelector('#age-back');
    var denied = modal.querySelector('#age-denied');
    var buttons = modal.querySelector('.age-buttons');

    if (yesBtn) yesBtn.addEventListener('click', function() {
      setVerified();
      modal.classList.add('hidden');
      document.body.classList.remove('age-lock');
    });

    if (noBtn) noBtn.addEventListener('click', function() {
      if (buttons) buttons.style.display = 'none';
      if (denied) denied.style.display = 'block';
    });

    if (backBtn) backBtn.addEventListener('click', function() {
      if (denied) denied.style.display = 'none';
      if (buttons) buttons.style.display = 'flex';
    });
  }

  function showModal(onVerified) {
    if (isVerified()) {
      if (onVerified) onVerified();
      return;
    }

    var modal = getModal();
    if (!modal) return;

    bindModalButtons(modal);
    modal.classList.remove('hidden');
    document.body.classList.add('age-lock');

    var yesBtn = modal.querySelector('#age-yes');
    if (yesBtn) {
      yesBtn.focus();
      if (onVerified) {
        yesBtn.addEventListener('click', function onYes() {
          yesBtn.removeEventListener('click', onYes);
          onVerified();
        }, { once: true });
      }
    }
  }

  function interceptFetch() {
    if (fetchIntercepted || !window.fetch) return;
    fetchIntercepted = true;

    var _fetch = window.fetch;
    window.fetch = function(url, options) {
      var urlStr = typeof url === 'string' ? url : (url && (url.url || url.href)) || '';

      // Only intercept cart/add calls
      if (!urlStr.includes('/cart/add')) {
        return _fetch.apply(this, arguments);
      }

      // Already verified - let it through
      if (isVerified()) {
        return _fetch.apply(this, arguments);
      }

      // Not verified - show modal and retry fetch after
      var self = this;
      var args = arguments;
      return new Promise(function(resolve, reject) {
        showModal(function() {
          _fetch.apply(self, args).then(resolve).catch(reject);
        });
      });
    };
  }

  function init() {
    if (isVerified()) return;

    // Show on cart page if not verified and cart has items
    if (window.location.pathname === '/cart') {
      if (Number(window.ageVerificationCartItemCount || 0) > 0) {
        showModal();
      }
      return;
    }

    // Intercept fetch for Ajax cart (Horizon uses this)
    interceptFetch();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

}();
